import axios from "axios";
import { useMutation, useQuery } from "react-query";
import {
  GetDriverListResponse,
  InviteDriversRequest,
  ValidationResponse,
} from "../models";

const API_PATH = "SalesOrders/";

export const useGetDriverList = () =>
  useQuery<GetDriverListResponse, Error>(
    "driver-list",
    () =>
      axios
        .get(`${API_PATH}GetDriverList`)
        .then((res) => res.data)
        .catch((error) => {
          console.error("Failed to fetch drivers:", error);
          throw error;
        }),
    {
      staleTime: 1000 * 60 * 5, // Cache for 5 minutes
      refetchOnWindowFocus: false,
    }
  );

export const useInviteDrivers = () =>
  useMutation<ValidationResponse, Error, InviteDriversRequest>(
    (inviteDriversRequest) =>
      axios
        .post(`${API_PATH}InviteDrivers`, inviteDriversRequest)
        .then((res) => res.data)
        .catch((error) => {
          console.error("Invite drivers failed:", error);
          return {
            success: false,
            errors: error.response?.data?.errors || [
              "An error occurred during invite drivers",
            ],
          };
        })
  );
